import _ from 'underscore';

export const isAudienceTooNarrow = audienceSize => !_.isUndefined(audienceSize) && audienceSize < 300;
